import { Search } from '@mui/icons-material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Box, Collapse, Divider, InputAdornment } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { BE_DATE_FORMAT, INDICATION_REQUEST_STATUS } from '../../../../common/constants';
import { ILayoutFields, ISchemaFields, ISchemaForm, IUiFields } from '../../../../common/SchemaForm/utils';
export interface SearchPrams {
  patientCode: string;
  status: string;
  patientName: string;
  interpreter: string;
  startDate: string;
  endDate: string;
}

const INDICATION_REQUEST_STATUS_OPTIONS = [
  INDICATION_REQUEST_STATUS.REQUESTED,
  INDICATION_REQUEST_STATUS.FINISHED,
  INDICATION_REQUEST_STATUS.CANCELLED,
];

export const fieldSchema: ISchemaFields = ({ valuesField, formProps }) => {
  const { intl, clearParams, state, setState } = formProps || {};

  return {
    patientCode: {
      type: 'text-field',
      placeholder: intl.formatMessage({ id: 'therapy.label.customer.enterCode' }),
      InputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <Search color="inherit" />
          </InputAdornment>
        ),
      },
      showClearBtn: true,
      propsWrapper: { xs: true, sx: { '&': { maxWidth: '400px' } } },
    },
    status: {
      type: 'select',
      hasAllOptions: true,
      label: intl.formatMessage({ id: 'status' }),
      multiple: true,
      options: INDICATION_REQUEST_STATUS_OPTIONS,
      propsWrapper: { xs: 4, xl: true },
    },
    patientName: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'sellingProduct.title.customerName' }),
      placeholder: intl.formatMessage({ id: 'sale.customerEnter' }),
      propsWrapper: { xs: 4, xl: true },
    },
    patientMobilePhone: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'telephone' }),
      placeholder: intl.formatMessage({ id: 'telephoneEnter' }),
      propsWrapper: { xs: 4, xl: true },
    },
    executeEmployeeName: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'interpreter' }),
      placeholder: intl.formatMessage({ id: 'interpreterEnter' }),
      propsWrapper: { xs: 4, xl: true },
    },
    fromDate: {
      type: 'datePicker',
      placeholder: intl.formatMessage({ id: 'birthdayForm' }),
      label: intl.formatMessage({ id: 'indicationDateFrom' }),
      propsWrapper: { xs: 4, xl: true },
      autoOk: true,
      maxDate: valuesField.endDate ? moment(valuesField.endDate).toDate() : null,
      required: false,
      register: {
        validate: (value) => {
          return value
            ? moment(value, BE_DATE_FORMAT, true).isValid()
              ? true
              : intl.formatMessage({ id: 'validation.invalidDate' })
            : true;
        },
      },
    },
    toDate: {
      type: 'datePicker',
      placeholder: intl.formatMessage({ id: 'birthdayForm' }),
      label: intl.formatMessage({ id: 'indicationDateTo' }),
      propsWrapper: { xs: 4, xl: true },
      autoOk: true,
      minDate: valuesField.startDate ? moment(valuesField.startDate).toDate() : null,
      register: {
        validate: (value) => {
          return value
            ? moment(value, BE_DATE_FORMAT, true).isValid()
              ? true
              : intl.formatMessage({ id: 'validation.invalidDate' })
            : true;
        },
      },
      required: false,
    },
    search: {
      type: 'submitButton',
      color: 'inherit',
      label: intl.formatMessage({ id: 'search' }),
      propsWrapper: { xs: undefined },
    },
    expand: {
      type: 'button',
      endIcon: (
        <ExpandLessIcon
          style={{
            transition: '0.2s all',
            transform: valuesField?.expand ? 'rotate(0deg)' : 'rotate(180deg)',
          }}
        />
      ),
      color: 'primary',
      variant: 'text',
      onClick: () => setState({ expand: !state.expand }),
      label: intl.formatMessage({ id: 'advance' }),
      propsWrapper: { xs: undefined },
    },

    reset: {
      type: 'button',
      onClick: () => clearParams && clearParams(),
      color: 'inherit',
      label: intl.formatMessage({ id: 'reset' }),
      propsWrapper: { xs: undefined },
      style: { minWidth: 120, marginTop: 20 },
    },
  };
};

const ui: IUiFields = () => {
  return [
    {
      id: 'layout',
      propsGridContainer: { spacing: 1, justifyContent: 'flex-end' },
      fields: ['patientCode', 'search', 'expand'],
    },
    {
      id: 'expand',
      fields: ['status', 'patientName', 'patientMobilePhone', 'executeEmployeeName', 'fromDate', 'toDate', 'reset'],
    },
    { id: 'submit', fields: ['save'] },
  ];
};

const LayoutSchema: ILayoutFields = (props) => {
  const { listElement, formProps } = props;
  const { state } = formProps;
  return (
    <>
      <Box display="flex">
        <Box flex={1}>{formProps?.pagin}</Box>
        <Box flex={1}>{listElement[0]}</Box>
      </Box>
      <Collapse in={state?.expand} style={{ marginTop: 16 }}>
        {listElement[1]}
        <Divider style={{ marginBottom: 16 }} />
      </Collapse>
    </>
  );
};

export const schemaFilterEncounterForm: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
  layout: LayoutSchema,
};
